<template lang="pug">
v-container
  v-card.pointer(v-for="category in categories" :key="category.id" class="mx-auto mb-1" max-width="400" @click.native="goToCategory(category)")
    v-card-title {{ category.name }}
    div.archive-info
        span(v-if="isMerch && categoryStatistic[category.id]") Сихронизировано {{ categoryStatistic[category.id].synced }} из {{ categoryStatistic[category.id].total }}
  v-card.pointer(v-if="selectedProject && selectedProject.motivationalReport"  class="mx-auto mb-1" max-width="400" @click.native="goToMotivationalReport")
    v-card-title Мотивационный отчёт

  v-card(v-if="loading" class="mx-auto" flat max-width="50")
    v-progress-circular(:size="50" color="primary" indeterminate)

  v-card(v-if="error" class="mx-auto" max-width="400")
    v-card-title Что-то пошло не по плану
      v-spacer
      v-icon(color="red") mdi-alert
    v-card-subtitle {{ error }}

</template>


<script>
// import { tradepointService, categoryService, projectService } from '@/_services'
import { mapState, mapMutations } from "vuex";
import dataService from "../../../_services/dataService";
import { offlineReportService } from "../../../_services/offlineReportService";

export default {
  props: [ 'id', 'nid', 'pid' ],

  data: () => ({
    loading: false,
    error: null,
    categories: [],
    categoryStatistic: {}
  }),

  mounted() {
    if (!this.selectedPoint) this.loadTradePointData()
    else this.setAppBarTitle(this.selectedPoint.address)
    this.loadCategories()
    if(!this.selectedProject) this.loadProject()
    window.addEventListener('app:online-sync', this.init)
  },

  destroyed() {
    this.setSelectedPoint(null)
    window.removeEventListener('app:online-sync', this.init)
  },

  computed: {
    ...mapState(['appBarTitle']),
    ...mapState("tradepoint", ["selectedPoint"]),
    ...mapState("project", ["selectedProject"]),

    isMerch() {
      let role = localStorage.getItem('role')
      return role == "MERCH"
    }
  },

  methods: {
    ...mapMutations(['setAppBarTitle']),
    ...mapMutations("tradepoint", ["setSelectedPoint"]),
    ...mapMutations("category", ["setSelectedCategory"]),
    ...mapMutations("project", ["setSelectedProject"]),

    init() {
      this.loadCategories()
      if(!this.selectedProject) this.loadProject()
    },

    async getCategoryStatistic(categories) {
      let statistic = {}
      for(const category of categories) {
        statistic[category.id] = await offlineReportService.getCategoryStatistic(this.pid, category.id)
      }
      this.categoryStatistic = statistic
    },

    loadProject() {
      dataService.loadProject(this.id).then(data => {
        this.setSelectedProject(data)
      })
    },

    loadTradePointData() {
      this.setAppBarTitle('loading')
      // tradepointService.loadPoint(this.pid)
      dataService.loadTradePoint(this.pid)
      .then(data => {
        this.setSelectedPoint(data)
        this.setAppBarTitle(data.address)
      })
      .catch(error => {
        this.setSelectedPoint(null)
        this.setAppBarTitle(error)
      })
    },

    loadCategories() {
      this.loading = true
      // categoryService.getpointcategories(this.pid, this.id)
      this.categories = []
      dataService.getCategories(this.pid, this.id)
      .then(data => {
        this.getCategoryStatistic(data)
        this.categories = data
        this.loading = false
      })
      .catch(error => {
        this.error = error
        this.loading = false
      })
    },

    goToCategory(c) {
      this.setSelectedCategory(c)
      this.$router.push(`/project/${this.id}/network/${this.nid}/tradepoint/${this.pid}/category/${c.id}`)
    },

    goToMotivationalReport() {
      this.$router.push(`/project/${this.id}/network/${this.nid}/tradepoint/${this.pid}/motivationalReport`)
    }
      
  }
}
</script>
<style scoped>
.archive-info {
  font-size: 10px;
  line-height: 22px;
  color: #00000099;
  width: 100%;
  margin-top: -10px;
  display: flex;
  padding: 0 16px 16px 16px;
}
</style>